import React from "react";
import { Subscribe } from 'unstated';
import ApplicationContainer from "../../../../shared/state/containers/ApplicationContainer";
import OrganizationContainer from "../../../../shared/state/containers/OrganizationContainer";
import AppliedApplicationTemplateContainer from "../../../../shared/state/containers/AppliedApplicationTemplateContainer";
import ApplicationDashboard from "./components/ApplicationDashboard";
import TemplateConfigurationContainer from "../../../../shared/state/containers/TemplateConfigurationContainer";
import ApplicationAnalyticsFacetContainer from "../../../../shared/state/containers/ApplicationAnalyticsFacetContainer";
import UserContainer from "../../../../shared/state/containers/UserContainer";
import MediaContainer from "../../../../shared/state/containers/MediaContainer";

interface BasicOrganizationApplicationsProps {
    history: any
}

const BasicOrganizationApplications: React.FC<BasicOrganizationApplicationsProps> = (props) => {

    return (
        <Subscribe to={[
            ApplicationContainer,
            OrganizationContainer,
            AppliedApplicationTemplateContainer,
            TemplateConfigurationContainer,
            ApplicationAnalyticsFacetContainer,
            UserContainer,
            MediaContainer
        ]}>
            {(
                appContainer: ApplicationContainer,
                orgContainer: OrganizationContainer,
                appliedAppTemplateContainer: AppliedApplicationTemplateContainer,
                templateConfigurationContainer: TemplateConfigurationContainer,
                facetContainer: ApplicationAnalyticsFacetContainer,
                userContainer: UserContainer,
                mediaContainer: MediaContainer
            ) => {
                return (
                    <ApplicationDashboard
                        appsContainer={appContainer}
                        organizationId={orgContainer.state.currentOrganization.id}
                        orgContainer={orgContainer}
                        appliedAppTemplateContainer={appliedAppTemplateContainer}
                        templateConfigurationContainer={templateConfigurationContainer}
                        facetContainer={facetContainer}
                        userContainer={userContainer}
                        mediaContainer={mediaContainer}
                        history={props.history}
                    />
                );
            }}
        </Subscribe>
    );
};

export default BasicOrganizationApplications;